(() => {
  function initializeNavigation() {
    const header = document.querySelector('.bnc-header-shell');
    if (!header || header.dataset.initialized) return;
    header.dataset.initialized = 'true';
    const trigger = header.querySelector('#shop-menu-button');
    const mega = header.querySelector('#mega-menu');
    const menu = header.querySelector('#mobile-menu');
    const mobileButton = header.querySelector('#mobile-menu-button');
    const closeMega = (restoreFocus = false) => {
      const open = !mega.hidden;
      mega.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (open && restoreFocus) trigger.focus();
    };
    trigger.addEventListener('click', () => {
      const open = mega.hidden;
      mega.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
    });
    mobileButton.addEventListener('click', () => menu.showModal());
    menu.querySelector('.close-dialog').addEventListener('click', () => menu.close());
    menu.addEventListener('click', event => {
      if (event.target.closest('a')) menu.close();
      if (event.target === menu) {
        const rect = menu.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) menu.close();
      }
    });
    document.addEventListener('click', event => { if (!header.contains(event.target)) closeMega(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMega(true); });
    document.addEventListener('focusin', event => { if (!header.contains(event.target)) closeMega(); });
    window.addEventListener('resize', () => {
      if (innerWidth <= 760) closeMega();
      if (innerWidth > 760 && menu.open) menu.close();
    });
  }
  initializeNavigation();
  document.addEventListener('shopify:section:load', initializeNavigation);
})();
